import { FormEvent, useEffect, useRef } from 'react';
import styles from './TextArea.module.css';

interface TextAreaProps
  extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  autoResize?: boolean;
}

const adjustTextAreaHeight = (textarea: HTMLTextAreaElement) => {
  textarea.style.height = 'auto';
  textarea.style.height = `${textarea.scrollHeight}px`;
};

function TextArea({ autoResize, ...props }: TextAreaProps): JSX.Element {
  const textAreaRef = useRef<HTMLTextAreaElement>(null);

  useEffect(() => {
    if (autoResize && textAreaRef.current) {
      adjustTextAreaHeight(textAreaRef.current);
    }
  }, []);

  const handleInput = (event: FormEvent<HTMLTextAreaElement>) => {
    if (autoResize) {
      adjustTextAreaHeight(event.currentTarget);
    }

    if (props.onInput) {
      props.onInput(event);
    }
  };
  return (
    <textarea
      {...props}
      ref={textAreaRef}
      onInput={handleInput}
      className={styles.textarea}
    ></textarea>
  );
}

export default TextArea;
